import React from 'react';

const ButtonLabeled = ({ children, onClick }) => {
    return(
        <button className="appButton__labeled" type="button" onClick={onClick}>
            {children}
        </button>
    )
}

export default ButtonLabeled;